<form [formGroup]="parentForm">
  <span class="date-label" [ngClass]="{'disabled': disabled}">{{ label }}</span>

  <div class="date-input">
    <div class="date-field data-field">
      <mat-form-field class="select" [floatLabel]="'never'" appearance="outline">
        <input matInput type="number" inputmode="numeric"
               placeholder="{{'yearPlaceholder' | translate}}" name="yyyydate"
               [formControlName]="dateYearFormName"
               (input)="onDateChanged()"
               min="1900" max="2100">
      </mat-form-field>
    </div>

    <div class="date-field data-field">
      <mat-form-field class="select" [floatLabel]="'never'" appearance="outline">
        <mat-select placeholder="{{'monthPlaceholder' | translate}}" name="mmdate"
                    [formControlName]="dateMonthFormName"
                    (selectionChange)="onDateChanged()">
          <mat-option *ngFor="let month of months" [value]="month">{{ month }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="date-field data-field">
      <mat-form-field class="select" [floatLabel]="'never'" appearance="outline">
        <mat-select placeholder="{{'dayPlaceholder' | translate}}" name="dddate"
                    [formControlName]="dateDayFormName"
                    (selectionChange)="onDateChanged()">
          <mat-option *ngFor="let day of days" [value]="day">{{ day }}</mat-option>
        </mat-select>

      </mat-form-field>
    </div>
  </div>

</form>
